import type { Rdns, Store } from 'mipd';

export const isProviderExistsEIP6963 = (providersStore: Store, rdns: Rdns) => {
  return Boolean(providersStore.findProvider({ rdns }));
};
